module.exports = __webpack_public_path__ + "img/sm.60d4c950.png";